module.exports = __webpack_public_path__ + "media/images/partners/arm-2817c19388ec39cc5b3e533d498422a7.svg";